import { Grid } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import ContentL from "./components/ContentL";
import ContentR from "./components/ContentR";
// import { useIntl } from 'react-intl'
// const intl = useIntl();
// {intl.formatMessage({id:'MENU.NEW'})}

function EmergencyManagement() {
    const [objectMaps, setObjectMaps] = useState({ latitude: 0, longitude: 0 });
    const handleViewMap = useCallback(data => {
        setObjectMaps({ latitude: data?.latitude, longitude: data?.longitude });
        window.open(`https://maps.google.com/?q=${data?.latitude},${data?.longitude}`);
    }, []);
    return (
        <div>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <h1 className="t-text-primary">Emergency</h1>
                </Grid>
                {/* content */}
                <Grid item xs={12}>
                    <Grid container spacing={5}>
                        <Grid item xs={12} md={7}>
                            <ContentL handleViewMap={handleViewMap} />
                        </Grid>
                        <Grid item xs={12} md={5} className="d-flex align-items-center">
                            <ContentR objectMaps={objectMaps} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

export default EmergencyManagement;
